export default __webpack_public_path__ + "static/media/hht1_ep16_timeline_q01_b.c310615a.png";